// eslint-disable-next-line import/no-cycle
import request from '@/utils/request';

export function login(userName, password, verifyCode, uuid) {
  return request({
    url: '/deployment-service/user/login',
    method: 'post',
    data: {
      name: userName,
      password,
      verify_code: verifyCode,
      uuid,
    },
  });
}

export function modifyPassword(id, oldPassword, password) {
  return request({
    url: '/deployment-service/user/update_password',
    method: 'post',
    data: {
      old_password: oldPassword,
      id,
      new_password: password,
    },
  });
}

export function getVerifyCode(uuid) {
  return request({
    url: '/deployment-service/user/get_verify_code',
    method: 'get',
    params: {
      uuid,
    },
  });
}

export function getInfo(token) {
  return request({
    url: '/deployment-service/user/analyze_token',
    method: 'post',
    data: {},
  });
}

export function logout() {
  // return request({
  //   url: '/user/logout',
  //   method: 'post'
  // })
  return new Promise((resolve, reject) => {
    resolve({
      error_no: 0,
      data: {},
    });
  });
}
